<template>
  <section>
    <b-row>
      <b-col sm="12" v-if="FrasesEt.edicion == 'generada'" style="color:green;">
        <h6><center>Esta modificacion aun no ha sido creada puede cambiar el tipo para generarla nuevamente</center></h6>
      </b-col>
      <b-col sm="12" v-if="FrasesEt.edicion == 'editada'" style="color:red;">
        <h6><center>Al reiniciar estas frases se podria generar nuevamente, se tendria que editar nuevamente</center></h6>
      </b-col>
    </b-row>
    <b-row>      
      <b-col sm="1" class="mb-4" v-if="FrasesEt.edicion == 'generada'">
        <label class="mr-sm-4 text-center" for="inline-form-custom-select-pref">Tipo</label>
        <br />
      </b-col>
      <b-col sm="4" class="mb-4" v-if="FrasesEt.edicion == 'generada'">
        <b-form-select
          v-model="tipo"
          :options="tipos.tipos"
          size="md"
          class="form-control"
          :disabled="disabledInputs"
          @change="cambiaTipo"
        />
      </b-col>
      <b-col sm="2" class="mb-2 ml-2">
      </b-col>
      <b-col sm="4" class="mb-2 ml-2" v-if="FrasesEt.edicion == 'editada'">
        <b-button
          style="display:block;margin:auto;"
          variant="danger"
          @click="reiniciaFrases()"
        >Reiniciar</b-button>
      </b-col>
      <b-col sm="4" class="mb-2 ml-2">
        <b-button
          style="display:block;margin:auto;"
          variant="success"
          @click="guardarFrases()"
        >Guardar</b-button>
      </b-col>
      
    </b-row>
  </section>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "frases-sga",
  components: {
  },
  data() {
    return {

    };
  },
  computed: {
    disabledInputs() {
      return this.selectedProductEt.finalizado == 0 ? false : true
    },
    ...mapState("sga_et", [
      "idiomas",
      "versiones",
      "version",
      "idioma",
      "tipos",
      "tipo",
      "filtro",
      "FrasesEt"
    ]),
    ...mapState('productos_et',[
      'selectedProductEt'
    ])
  },
  methods: {
    reiniciaFrases(){
      if ( confirm('Esta accion eliminara cualquier edicion hecha en las frases.') ) {       
        this.reiniciarFrases();
      }
    },
    async cambiaEmpresa(empresa){
      this.cambiarEmpresa(empresa);
      await this.getFrases();
    },
    async cambiaIdioma(idioma){
      this.cambiarIdioma(idioma);
      await this.getFrases();
    },
    async cambiaVersion(version){
      this.cambiarVersion(version);
      await this.getFrases();
    },
    async cambiaTipo(tipo){
      this.cambiarTipo(tipo);
      await this.getFrases();
    },

    ...mapActions("sga_et", ["getFrases","reiniciarFrases","guardarFrases","cambiarEmpresa"]),
    ...mapMutations("sga_et", ["cambiarIdioma", "cambiarVersion", "cambiarTipo","limpiarEmpresa"]),
    async limpiar() {
      this.filtro.empresa = '';
      await this.cambiaEmpresa('');
      await this.limpiarEmpresa();
      await this.getFrases();
    }
  }
};
</script>

<style scoped>
.tox-notifications-container {
  display: none !important;
}
.mce-notification {
  display: none !important;
}
</style>